"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_SEND_OPTIONS = void 0;
exports.DEFAULT_SEND_OPTIONS = {
    connect: true,
    sendIfStopped: false,
    doNotBufferWhileConnecting: false
};
//# sourceMappingURL=ITransport.js.map